import { GlobalState } from '@leverege/ui-redux';
import { Relationships } from '@leverege/molten/data-source';
import { Attributes } from '@leverege/ui-attributes';
import Types from "../../constants/Types.js";
import DeviceTypeGroupDelegate from "../../delegates/deviceType/DeviceTypeGroupDelegate.js";
export default (({
  objectType
}) => ({
  name: 'deviceType',
  objectType,
  valueType: Types.deviceType,
  linkAttributes: true,
  get: data => {
    // TODO: do we need to get this from anywhere besides the root?
    const relationship = Relationships.getByPath('leverege.fotaApi.deviceType');
    const delegate = new DeviceTypeGroupDelegate({
      relationship,
      match: {}
    });
    const deviceTypeId = Attributes.get('deviceTypeId', objectType, data);
    return delegate.getItem(deviceTypeId, GlobalState.get());
  },
  load: async (data, context) => {
    const deviceType = Attributes.get('deviceType', objectType, data);
    const deviceTypeId = Attributes.get('deviceTypeId', objectType, data);
    // we have one but its not loaded yet
    if (!deviceType && deviceTypeId) {
      const relationship = Relationships.getByPath('leverege.fotaApi.deviceType');
      const delegate = new DeviceTypeGroupDelegate({
        relationship,
        match: {}
      });
      // this has to use coalesce server requests or we'll spam the server
      await GlobalState.dispatch(delegate.get(deviceTypeId));
    }
  },
  displayName: 'Device Type',
  source: {
    type: Types.apiName,
    editable: false,
    creatable: false
  }
}));